import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const copiarCuadroTurnos = async (data) => {
    try {
        const resp = await axios.post(`${API_URL}/cuadroTurnos/copiar`, data, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerCuadroTurnos = async (dateRange) => {
    try {
        const resp = await axios.post(
            `${API_URL}/cuadroTurnos/listarCuadrosTurnos`,
            dateRange,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const editarCuadrosTurnos = async (nuevoIdTurnoSede, cuadrosTurnosAEditar) => {
    try {
        const data = { turno_sede_id: nuevoIdTurnoSede, cuadros_turnos_a_editar: cuadrosTurnosAEditar };
        const resp = await axios.put(
            `${API_URL}/cuadroTurnos`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const intercambiarCuadrosTurnos = async (IdsCuadrosTurnos) => {
    try {
        const data = { ids_cuadros_turnos: IdsCuadrosTurnos };
        const resp = await axios.put(
            `${API_URL}/cuadroTurnos/intercambiar`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerDiasFestivos = async () => {
    try {
        const resp = await axios.get(`${API_URL}/cuadroTurnos/festivos`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

/**
 * @description Función que comprueba si se puede generar el cuadro de turno para el mes siguiente,
 * retorna true si el cuadro de turno puede ser generado, y false si no es así.
 *
 * @returns {true|false}
 */
export const comprobarCuadroTurnoAutomatico = async () => {
    try {
        const response = await axios.get(`${API_URL}/comprobarCuadroTurnos`, {
            headers: getHeaders(),
        });

        return response.data;
    } catch (error) {
        return error.response.data;
    }
};

export const generarCuadroTurnos = async (data = {}) => {
    try {
        const response = await axios.post(
            `${API_URL}/cuadroTurnos/generarCuadroTurnos`,
            data,
            { headers: getHeaders() }
        );

        return response.data;
    } catch (error) {
        return error.response.data;
    }
};

export const eliminarCuadroTurnos = async (data = {}) => {
    try {
        const response = await axios.post(
            `${API_URL}/cuadroTurnos/eliminarCuadroTurnos`,
            data,
            { headers: getHeaders() }
        );

        return response.data;
    } catch (error) {
        return error.response.data;
    }
};

export const eliminarCuadroTurnosPorPersona = async (
    inicio,
    fin,
    area,
    persona
) => {
    try {
        const response = await axios.post(
            `${API_URL}/cuadroTurnos/eliminarCuadroTurnosPorPersona`,
            {
                fechaCuadroTurnoInicio: inicio,
                fechaCuadroTurnoFin: fin,
                idSedeArea: area,
                persona_id: persona,
            },
            { headers: getHeaders() }
        );

        return response.data;
    } catch (error) {
        return error.response.data;
    }
};

export const exportarCuadroTurnos = async (
    fechaInicio,
    fechaFin,
    area = null,
    subAreas = null,
    turnos = null,
) => {
    try {
        const response = await axios.post(
            `${API_URL}/cuadroTurnos/exportar`,
            { fechaInicio, fechaFin, area, subAreas, turnos },
            { headers: getHeaders() }
        );

        return response.data;
    } catch (error) {
        return error.response.data;
    }
};
